<div class="container">
    <div class="logo">
        <img src="/assets/images/calendarhero/Full-Color-Dark-Bgrd-2x.png" />
    </div>

    <hr />

    <div class="header">
        <p class="main">Automated Scheduling</p>
        <p class="sub">The smartest way to schedule</p>
    </div>

    <div class="list">
        <div class="list-item">
            <div>
                <i class="calendar alternate outline icon" aria-hidden="true"></i>
            </div>
            <p>Quickly share your real-time availability with contacts</p>
        </div>

        <div class="list-item">
            <div>
                <i class="icon clock outline"></i>
            </div>
            <p>Create and send automated meeting requests from your inbox</p>
        </div>

        <div class="list-item">
            <div>
                <i class="icon info circle"></i>
            </div>
            <p>Instantly find mutual availability for meetings with team members</p>
        </div>
    </div>

    <hr />

    <p class="auth">Authenticate your {{ extension }} account to get started!</p>
    <div class="buttons">
        <ng-container *ngIf="extension === 'Microsoft'; else showAuthenticateChrome">
            <button class="ui white button" (click)="authenticateMS('outlook')" type="fixed-white">Authenticate</button>
            <a class="item" routerLink="/authLegacy">Authenticate with Exchange</a>
        </ng-container>
        <ng-template #showAuthenticateChrome>
            <button (click)="authenticateGoogle()" type="fixed-white">Authenticate</button>
        </ng-template>
    </div>
    <div class="ui active inverted dimmer" *ngIf="isAuthenticating">
        <div class="ui text loader">
            <p>Authenticating...</p>
        </div>
    </div>
</div>
